import classNames from 'classnames'
import React from 'react'
import elementType from 'prop-types-extra/lib/elementType'

import { bsClass, getClassSet, splitBsProps } from '../../utils'

const propTypes = {
  componentClass: elementType
}

const defaultProps = {
  componentClass: 'h4'
}

class ModalTitle extends React.PureComponent {
  render() {
    const { componentClass: Component, className, ...props } = this.props
    const [bsProps, elementProps] = splitBsProps(props)

    const classes = getClassSet(bsProps)

    return (
      <Component {...elementProps} className={classNames(className, classes)} />
    )
  }
}

ModalTitle.propTypes = propTypes
ModalTitle.defaultProps = defaultProps

export default bsClass('modal-title', ModalTitle)



// WEBPACK FOOTER //
// ./components/ModalTitle/index.jsx